import firebase from "../../firebase";

export default function({ officeId, userId }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "messagingAdmin",
        funcName: "removeUser",
        data: { officeId, userId }
    });
}
